import * as actions from './apartment.actions';
import watch from './apartment.operations';
import reducer, { initState } from './apartment.reducers';

export { actions, watch, initState };

export default reducer;
